// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc-answer[data-v-b5a85fe2]{font-family:Noto Sans JP;letter-spacing:1px;font-size:15px;text-align:center;color:#fff;white-space:pre-wrap;word-wrap:break-word;margin-top:16px;padding:0 16px}", ""]);
// Exports
module.exports = exports;
